import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { ProjectData } from '@/types/project';
import { formatCurrency } from '@/utils/formatters';

interface BudgetFormProps {
  data: ProjectData;
  onChange: (type: 'value' | 'costs', value: number | null) => void;
}

export function BudgetForm({ data, onChange }: BudgetFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center">
          Budget
          <span className="text-sm font-normal text-muted-foreground" aria-label="Budget summary">
            {formatCurrency(data?.value?.budgetedRevenue || 0)} / {formatCurrency(data?.costs?.budgetedCosts || 0)}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label htmlFor="budgetedValue">Budgeted Value (£)</Label>
            <Input
              id="budgetedValue"
              type="number"
              value={data?.value?.budgetedRevenue || ''}
              onChange={(e) => onChange('value', e.target.value ? Number(e.target.value) : null)}
              placeholder="Enter budgeted value"
              className="text-right"
              aria-label="Budgeted value input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="budgetedCosts">Budgeted Costs (£)</Label>
            <Input
              id="budgetedCosts"
              type="number"
              value={data?.costs?.budgetedCosts || ''}
              onChange={(e) => onChange('costs', e.target.value ? Number(e.target.value) : null)}
              placeholder="Enter budgeted costs"
              className="text-right"
              aria-label="Budgeted costs input"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}